import { Observable } from 'rxjs';
import * as URI from 'uri-js';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { EM1 } from '../app.interfaces';

export enum EMStatus {
  Connectors,
  CreateConnector,
}

export class ReAuthResponse {
  isSuccessful: boolean;
  apiToken: string;
}

export class AuthorizationUrl {
  url: string;
}

export class UpdateResponse {
  result: boolean;
}

@Injectable({providedIn: 'root'})
export class SegmentationMembersApi {
  baseUrl: string;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = URI.resolve(
      environment.segmentationMembersApiUrl,
      'segment/'
    );
  }

  getConnectors(accountKey: string, segmentId:string, pageSize: number, pageId: number, columnName:string, ascOrDesc:string ): Observable<EM1> {
    let url = URI.resolve(this.baseUrl, `list/${accountKey}/${segmentId}/`);
    url += `?pageSize=${pageSize}`;
    url += `&pageId=${pageId}`;
    if(!(columnName === null) ||!( ascOrDesc === null) ){
      url += `&orderBy=${columnName}`;
      url += `&sort=${ascOrDesc}`;
    }
    
    return this.httpClient.get<EM1>(url);
  }
}

